'use strict';

require(['componentLoader'], function (helper) {

  // This site's module parameters
  helper.updateConfig({
    ajaxBasket: {
      excludeTick: true,
      recommendationsParentClass: 'recommendations-section',
      recommendationsHeaderClass: 'heading',
      recommendationsClass: 'item',
      recommendationsHeaderEncloseElement: 'h3',
      maxRecommendations: 4,
      thumbnailImageSize: 'large',
      fb_minWidth: 700,
      fb_minHeight: 515
    },
    quickView: {
      minWidth: 1010,
      minHeight: 400
    }
  });

  // Make these modules dependencies
  helper.promote(['editorialVideoScript']);

  helper.requireDependencies();
});

define(['jquery', 'siteObj', 'common'], function ($, siteObj) {

  var Coggles = function Coggles() {
    var self = this;

    function initHelpSites() {
      require(['helpSites'], function (helpSitePop) {
        helpSitePop.init(siteObj, ['en_US'], ['help.coggles.com']);
      });
    }

    function initLoginPageScript() {
      //login page scripts
      if (siteObj.page === 'login') {
        require(['loginPage']);
      }
    }

    function initAccountPageScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    }

    function initProductPageScript() {
      if (siteObj.type === 'product') {
        require(['reviewPaging']);

        var $variationDropDowns = $('.variation-dropdowns');
        if ($variationDropDowns.length > 0 && $('#opts-4').length > 0 && $('ul.colour-swatches-list').length < 1 || $variationDropDowns.length > 0 && $('#opts-2').length > 0) {
          require(['colourswatches'], function (colourswatches) {
            colourswatches.colourSwatchesForSelectBoxWithLabel('opts-4');
            window.colourPicker();
          });
        }
      }
    }

    function initLivepersonScript() {
      // Liveperson
      if (siteObj.props.testApps.lp === true) {
        require(['livePerson']);
      }
    }

    function initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active === true) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }

      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    }

    function initFancyBoxFeatures() {
      require(['fancyBoxFeatures'], function (fancyBoxFeatures) {
        fancyBoxFeatures.setupDefaults({
          'height': 'autoSize',
          'width': 1010,
          'minWidth': 350,
          'maxWidth': 1010,
          'minHeight': 320,
          'margin': 0,
          'padding': 15,
          'overflow': 'visible'
        });
        fancyBoxFeatures.setupProductPromo();
        fancyBoxFeatures.setupVariationOnPages(siteObj);
      });
    }

    function initSiteFeatures() {
      require(['siteFeatures'], function (siteFeatures) {
        siteFeatures.readMore(siteObj.type);
      });
    }

    function initYouTube() {
      /* Youtube videos /videos/youtube-main.js - load the API and render via youtubePlayer */
      require(['youtube'], function (youtube) {
        youtube('.js-youtube-video').done(function () {
          // ytVideosArray: array of Youtube videos and player Api controls for further
          // customisation

          var activeYTThumbClass = 'widget-youtube__gallery__menu__items__item--active';
          $('.youtube-video__gallery__menu__item').on('click', function () {
            $('.youtube-video__gallery__menu__item').removeClass(activeYTThumbClass);
            $(this).addClass(activeYTThumbClass);
          });
        });
      });
    }

    function initGoogleMap() {
      // Function for populating the google maps on salon pages
      var locationMap = $('#map-canvas');
      if (locationMap.length) {

        if (siteObj.maps.postcode.length && siteObj.maps.postcode !== '') {

          siteObj.fn.loadmap = function () {

            var geocoder = new window.google.maps.Geocoder();

            var contentString = '<div class="googleMaps">' + '<h2 class="googleMaps_title">' + siteObj.maps.title + '</h2>' + '<div class="googleMaps_address">' + siteObj.maps.address + '</div>' + '</div>';

            geocoder.geocode({
              'address': siteObj.maps.postcode
            }, function (results) {

              var location = results[0].geometry.location;
              var lat = location.lat();
              var lng = location.lng();
              var latlng = new window.google.maps.LatLng(lat + 0.005, lng);

              var mapOptions = {
                zoom: 14,
                center: location,
                mapTypeId: window.google.maps.MapTypeId.ROADMAP
              };

              var map = new window.google.maps.Map(document.getElementById('map-canvas'), mapOptions);

              map.panTo(latlng);

              var marker = new window.google.maps.Marker({
                position: location,
                map: map,
                title: siteObj.maps.postcode
              });

              var infowindow = new window.google.maps.InfoWindow({
                content: contentString
              });

              infowindow.open(map, marker);

              window.google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
              });
            });
          };

          siteObj.fn.loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBRWqpVDemRjVjXtI_FrUBpDoQXTvBnfhU&v=3.exp&sensor=false&callback=siteObj.fn.loadmap');
        }
      }
    }

    function init() {

      self.initHelpSites();

      self.initLoginPageScript();

      self.initAccountPageScript();

      self.initProductPageScript();

      self.initLivepersonScript();

      self.initGandalfScript();

      self.initFancyBoxFeatures();

      self.initSiteFeatures();

      self.initYouTube();

      self.initGoogleMap();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }

    self.init = init;
    self.initHelpSites = initHelpSites;
    self.initLoginPageScript = initLoginPageScript;
    self.initAccountPageScript = initAccountPageScript;
    self.initProductPageScript = initProductPageScript;
    self.initLivepersonScript = initLivepersonScript;
    self.initGandalfScript = initGandalfScript;
    self.initFancyBoxFeatures = initFancyBoxFeatures;
    self.initSiteFeatures = initSiteFeatures;
    self.initYouTube = initYouTube;
    self.initGoogleMap = initGoogleMap;
  };

  var cog = new Coggles();
  cog.init();
  return cog;
});
//# sourceMappingURL=coggles.js.map
